module.exports = __webpack_public_path__ + "img/af.549f7154.svg";